import makeStyles from "@mui/styles/makeStyles";
import { memo } from "react";
import { EditPickupPartnerRow } from "./EditPickupPartnerRow";
import { View } from "../../Base";

const useStyles = makeStyles({
  headerRow: {
    display: "flex",
    flexDirection: "row-reverse",
    gap: "1rem",
    margin: "0.25rem 0rem 1rem 0rem",
  },
  header: { width: "10.5rem" },
});

export const EditPickupContent = memo(
  ({ routeEdit, pickupModalGridConfig, onEdit }) => {
    const styles = useStyles();
    return (
      <View>
        <View className={styles.headerRow}>
          <View className={styles.header}>Collections:</View>
          <View className={styles.header}>Deliveries:</View>
        </View>
        {pickupModalGridConfig.map(
          ({ groupKey, groupLabel, deliveryColumn, collectionColumn }) => (
            <EditPickupPartnerRow
              key={groupKey}
              label={groupLabel}
              deliveryColumn={deliveryColumn}
              collectionColumn={collectionColumn}
              routeEdit={routeEdit}
              onEdit={onEdit}
            />
          )
        )}
      </View>
    );
  }
);
